import { type UseMutationOptions, useMutation } from "@tanstack/react-query";
import { dataSourceService } from "@/lib/services";
import type { DataCollection, DataCollectionUpdatePayload, DataResponse } from "@/types";

export type ResponseUpdateDataSource = DataResponse<DataCollection>;

export type UpdateDataSourceVariables = { collectionUuid: string; data: DataCollectionUpdatePayload };

type UpdateDataSourceMutationOptions = Omit<
  UseMutationOptions<ResponseUpdateDataSource, Error, UpdateDataSourceVariables>,
  "mutationFn"
>;

export const useUpdateDataSource = (options?: UpdateDataSourceMutationOptions) => {
  return useMutation<ResponseUpdateDataSource, Error, UpdateDataSourceVariables>({
    mutationFn: ({ collectionUuid, data }) => dataSourceService.update(collectionUuid, data),
    ...options,
  });
};
